import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var TagIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        style: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M18.789 2.364a3 3 0 012.852 2.954l-.003.19-.311 6.32a3 3 0 01-.724 1.811l-.151.164-7.96 7.96a3 3 0 01-4.115.12l-.128-.12-6.01-6.01a3 3 0 01-.121-4.115l.12-.128 7.96-7.96a3 3 0 011.753-.856l.222-.02 6.32-.31a3 3 0 01.296 0zM18.69 4.36h-.098l-6.321.311a1 1 0 00-.566.21l-.092.082-7.96 7.96a1 1 0 00-.078 1.327l.078.087 6.01 6.01a1 1 0 001.327.078l.088-.078 7.96-7.96a1 1 0 00.278-.535l.013-.123.311-6.32a1 1 0 00-.95-1.049zm-.779 1.73a2.5 2.5 0 11-3.535 3.535A2.5 2.5 0 0117.91 6.09zM15.79 7.503a.5.5 0 10.707.707.5.5 0 00-.707-.707z",
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    });
};
TagIcon.isCarinaIcon = true;
export default TagIcon;
